import React from "react";
import { useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import { toast } from "sonner";
import { useData } from "@/context/DataContext";
import { sumarDias, hoyISO } from "@/lib/zona";
import { useMarcarHecho } from "@/components/asuntos/CierreAsunto";
import { OcurrenciaCard } from "@/components/gestiones/Ocurrencias";
import { Personas } from "@/components/personas/Avatar";

const TAG = {
  Atrasado: "bg-[#FEE2E2] text-[#991B1B]", "Para hoy": "bg-[#FEF3C7] text-[#92400E]", "Cita próxima": "bg-[#DBEAFE] text-[#1E40AF]",
  "Vence pronto": "bg-[#FFEDD5] text-[#9A3412]", "Pago pendiente": "bg-[#FFEDD5] text-[#9A3412]", "Seguimiento pendiente": "bg-[#EDE9FE] text-[#5B21B6]",
};
export const Etiqueta = ({ t }) => <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-sm font-bold ${TAG[t] || "bg-[#F2EDE4] text-[#4A5550]"}`}>{t === "Atrasado" && <Icons.AlertTriangle size={14} />}{t}</span>;
const btn = "min-h-[44px] px-3.5 rounded-xl font-semibold text-sm inline-flex items-center gap-1.5";

const Item = ({ it }) => {
  const navigate = useNavigate();
  const marcar = useMarcarHecho();
  const { crearRecordatorio } = useData();
  const despues = async () => {
    try { await crearRecordatorio({ asunto_id: it.m.id, reminder_date: sumarDias(hoyISO(), 1), reminder_time: "09:00", text: `Recordatorio: ${it.m.title}` }); toast.success("Te lo recordaré mañana a las 09:00"); }
    catch { toast.error("No se pudo programar."); }
  };
  const ver = () => navigate(it.kind === "matter" ? `/asunto/${it.id}` : it.r.asunto_id ? `/asunto/${it.r.asunto_id}` : "/correos");
  return (
    <li data-testid={`atencion-item-${it.id}`} className="bg-white border border-[#E5DFD5] rounded-2xl p-4 space-y-2.5">
      <Etiqueta t={it.etiqueta} />
      <div><p className="font-heading font-bold text-lg text-[#1C2421]">{it.titulo}</p>{it.sub && <p className="text-base text-[#4A5550]">{it.sub}</p>}<Personas ids={it.personas} /></div>
      <div className="flex flex-wrap gap-2">
        <button data-testid={`atencion-ver-${it.id}`} onClick={ver} className={`${btn} bg-[#1C2421] text-white`}>Ver asunto</button>
        {it.kind === "matter" && <button data-testid={`atencion-hecho-${it.id}`} onClick={() => marcar(it.m)} className={`${btn} bg-[#3A6B56] text-white`}><Icons.Check size={16} /> Marcar como realizado</button>}
        {it.kind === "matter" && <button data-testid={`atencion-despues-${it.id}`} onClick={despues} className={`${btn} bg-white border border-[#E5DFD5] text-[#4A5550]`}><Icons.Clock size={16} /> Recordármelo después</button>}
      </div>
    </li>
  );
};

export const NecesitaAtencion = ({ items, ocs, recargarOcs }) => {
  const hoy = hoyISO();
  if (!items.length && !ocs.length) return null;
  const atrasadasOc = ocs.filter((o) => o.fecha < hoy);
  const hoyOc = ocs.filter((o) => o.fecha >= hoy);
  const ocBloque = (lista, tag) => lista.map((o) => (
    <li key={o.id} className="space-y-1.5" data-testid={`atencion-oc-${o.id}`}><Etiqueta t={tag} /><OcurrenciaCard o={o} onChange={recargarOcs} /></li>
  ));
  const g0 = items.filter((i) => i.grupo === 0), g1 = items.filter((i) => i.grupo === 1), g2 = items.filter((i) => i.grupo === 2);
  return (
    <section className="space-y-3" data-testid="home-atencion">
      <h2 className="font-heading text-xl font-bold text-[#1C2421]">Necesita tu atención</h2>
      <ul className="space-y-3">
        {g0.map((it) => <Item key={it.id} it={it} />)}
        {ocBloque(atrasadasOc, "Atrasado")}
        {g1.map((it) => <Item key={it.id} it={it} />)}
        {ocBloque(hoyOc, "Para hoy")}
        {g2.map((it) => <Item key={it.id} it={it} />)}
      </ul>
    </section>
  );
};
